// Theme presets for Brazyy's Clock-In Dashboard
export const THEMES = {
  brazyy_pink: {
    id: 'brazyy_pink',
    name: 'Brazyy Pink',
    description: 'Soft pink, red and warm gold — the signature look',
    preview: ['#FFB5C8', '#E8341C', '#F5A623'],
    vars: {
      '--bg-primary': '#FFF5F7',
      '--bg-secondary': '#FFE8EE',
      '--bg-card': '#FFFFFF',
      '--bg-sidebar': '#FFF0F4',
      '--accent-primary': '#E8341C',
      '--accent-secondary': '#F5A623',
      '--accent-soft': '#FFB5C8',
      '--accent-hover': '#C42A16',
      '--text-primary': '#2D1B1E',
      '--text-secondary': '#7A4A52',
      '--text-muted': '#B08090',
      '--border': '#F2C4CE',
      '--border-strong': '#E8A0B0',
      '--success': '#2ECC71',
      '--danger': '#E74C3C',
      '--warning': '#F39C12',
      '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(232,52,28,0.10)',
      '--shadow-card': '0 2px 12px rgba(232,52,28,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #FFE8EE 0%, #FFF5F7 50%, #FFF0E8 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #E8341C, #F5A623)',
      '--font-display': '"Fredoka One", cursive',
      '--font-body': '"Nunito", sans-serif',
    }
  },

  midnight_gold: {
    id: 'midnight_gold',
    name: 'Midnight Gold',
    description: 'Dark navy and black with rich gold accents',
    preview: ['#1A1F3A', '#F5A623', '#2C3358'],
    vars: {
      '--bg-primary': '#0F1220',
      '--bg-secondary': '#1A1F3A',
      '--bg-card': '#1E2440',
      '--bg-sidebar': '#151929',
      '--accent-primary': '#F5A623',
      '--accent-secondary': '#FFD700',
      '--accent-soft': '#3A2F10',
      '--accent-hover': '#D4881C',
      '--text-primary': '#F0E6CC',
      '--text-secondary': '#B8A880',
      '--text-muted': '#6B6040',
      '--border': '#2A3050',
      '--border-strong': '#3A4070',
      '--success': '#2ECC71',
      '--danger': '#E74C3C',
      '--warning': '#F39C12',
      '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(0,0,0,0.40)',
      '--shadow-card': '0 2px 12px rgba(0,0,0,0.30)',
      '--gradient-hero': 'linear-gradient(135deg, #0F1220 0%, #1A1F3A 50%, #1E2440 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #F5A623, #FFD700)',
      '--font-display': '"Cinzel", serif',
      '--font-body': '"Raleway", sans-serif',
    }
  },

  royal_purple: {
    id: 'royal_purple',
    name: 'Royal Purple',
    description: 'Deep purple and lavender with soft white',
    preview: ['#6B3FA0', '#C9A8FF', '#F3EEFF'],
    vars: {
      '--bg-primary': '#F8F5FF',
      '--bg-secondary': '#EDE5FF',
      '--bg-card': '#FFFFFF',
      '--bg-sidebar': '#F0EAFF',
      '--accent-primary': '#7B52C1',
      '--accent-secondary': '#C9A8FF',
      '--accent-soft': '#E8DAFF',
      '--accent-hover': '#6340A8',
      '--text-primary': '#1E0F3A',
      '--text-secondary': '#5A3A8A',
      '--text-muted': '#9B80C0',
      '--border': '#D8C8F0',
      '--border-strong': '#C0A8E0',
      '--success': '#2ECC71',
      '--danger': '#E74C3C',
      '--warning': '#F39C12',
      '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(123,82,193,0.12)',
      '--shadow-card': '0 2px 12px rgba(123,82,193,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #EDE5FF 0%, #F8F5FF 50%, #F0EAFF 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #7B52C1, #C9A8FF)',
      '--font-display': '"Playfair Display", serif',
      '--font-body': '"Lato", sans-serif',
    }
  },

  ocean_blue: {
    id: 'ocean_blue',
    name: 'Ocean Blue',
    description: 'Navy and sky blue with cool crisp white',
    preview: ['#1B4F8A', '#5BA4F5', '#EAF4FF'],
    vars: {
      '--bg-primary': '#F0F7FF',
      '--bg-secondary': '#E0EFFF',
      '--bg-card': '#FFFFFF',
      '--bg-sidebar': '#E8F3FF',
      '--accent-primary': '#2563EB',
      '--accent-secondary': '#5BA4F5',
      '--accent-soft': '#BFDBFE',
      '--accent-hover': '#1D4ED8',
      '--text-primary': '#0F1E3A',
      '--text-secondary': '#2A4A7A',
      '--text-muted': '#6A8AAA',
      '--border': '#C0D8F0',
      '--border-strong': '#90B8E0',
      '--success': '#2ECC71',
      '--danger': '#E74C3C',
      '--warning': '#F39C12',
      '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(37,99,235,0.10)',
      '--shadow-card': '0 2px 12px rgba(37,99,235,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #E0EFFF 0%, #F0F7FF 50%, #E8F3FF 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #2563EB, #5BA4F5)',
      '--font-display': '"Outfit", sans-serif',
      '--font-body': '"Source Sans 3", sans-serif',
    }
  },

  crimson: {
    id: 'crimson',
    name: 'Crimson',
    description: 'Deep red and black with silver accents',
    preview: ['#8B0000', '#C0C0C0', '#1A0000'],
    vars: {
      '--bg-primary': '#0D0000',
      '--bg-secondary': '#1A0000',
      '--bg-card': '#200000',
      '--bg-sidebar': '#150000',
      '--accent-primary': '#CC0000',
      '--accent-secondary': '#C0C0C0',
      '--accent-soft': '#400000',
      '--accent-hover': '#AA0000',
      '--text-primary': '#FFE8E8',
      '--text-secondary': '#C08080',
      '--text-muted': '#804040',
      '--border': '#300000',
      '--border-strong': '#500000',
      '--success': '#2ECC71',
      '--danger': '#FF4444',
      '--warning': '#F39C12',
      '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(0,0,0,0.50)',
      '--shadow-card': '0 2px 12px rgba(200,0,0,0.15)',
      '--gradient-hero': 'linear-gradient(135deg, #0D0000 0%, #1A0000 50%, #200000 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #CC0000, #FF4444)',
      '--font-display': '"Bebas Neue", cursive',
      '--font-body': '"IBM Plex Sans", sans-serif',
    }
  },

  monochrome: {
    id: 'monochrome',
    name: 'Monochrome',
    description: 'Clean black and white with sharp contrast',
    preview: ['#000000', '#FFFFFF', '#888888'],
    vars: {
      '--bg-primary': '#F8F8F8',
      '--bg-secondary': '#F0F0F0',
      '--bg-card': '#FFFFFF',
      '--bg-sidebar': '#FAFAFA',
      '--accent-primary': '#111111',
      '--accent-secondary': '#555555',
      '--accent-soft': '#E8E8E8',
      '--accent-hover': '#333333',
      '--text-primary': '#111111',
      '--text-secondary': '#444444',
      '--text-muted': '#888888',
      '--border': '#E0E0E0',
      '--border-strong': '#C0C0C0',
      '--success': '#2ECC71',
      '--danger': '#E74C3C',
      '--warning': '#F39C12',
      '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(0,0,0,0.08)',
      '--shadow-card': '0 2px 12px rgba(0,0,0,0.06)',
      '--gradient-hero': 'linear-gradient(135deg, #F0F0F0 0%, #F8F8F8 50%, #FFFFFF 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #111111, #555555)',
      '--font-display': '"DM Serif Display", serif',
      '--font-body': '"DM Sans", sans-serif',
    }
  },

  sunset_orange: {
    id: 'sunset_orange',
    name: 'Sunset Orange',
    description: 'Warm oranges and amber glow',
    preview: ['#FF8C42', '#FF6B1A', '#FFD7A8'],
    vars: {
      '--bg-primary': '#FFF8F2', '--bg-secondary': '#FFEEDD', '--bg-card': '#FFFFFF', '--bg-sidebar': '#FFF2E6',
      '--accent-primary': '#FF6B1A', '--accent-secondary': '#FFA64D', '--accent-soft': '#FFD7A8', '--accent-hover': '#E55A0F',
      '--text-primary': '#3D2410', '--text-secondary': '#8A5A30', '--text-muted': '#C09060',
      '--border': '#F5D5B5', '--border-strong': '#E8B888',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#F39C12', '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(255,107,26,0.12)', '--shadow-card': '0 2px 12px rgba(255,107,26,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #FFEEDD 0%, #FFF8F2 50%, #FFF2E6 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #FF6B1A, #FFA64D)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"Nunito", sans-serif',
    }
  },

  military_green: {
    id: 'military_green',
    name: 'Military Green',
    description: 'Olive drab and tactical earth tones',
    preview: ['#4B5320', '#7C8B3D', '#A8B074'],
    vars: {
      '--bg-primary': '#F5F6F0', '--bg-secondary': '#E8EBDD', '--bg-card': '#FFFFFF', '--bg-sidebar': '#EDF0E4',
      '--accent-primary': '#5A6B23', '--accent-secondary': '#7C8B3D', '--accent-soft': '#C5CDA0', '--accent-hover': '#48551C',
      '--text-primary': '#252A15', '--text-secondary': '#4F5A30', '--text-muted': '#8A9460',
      '--border': '#D0D6BC', '--border-strong': '#B0BA90',
      '--success': '#2ECC71', '--danger': '#C0392B', '--warning': '#D68910', '--info': '#5499C7',
      '--shadow': '0 4px 24px rgba(75,83,32,0.12)', '--shadow-card': '0 2px 12px rgba(75,83,32,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #E8EBDD 0%, #F5F6F0 50%, #EDF0E4 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #5A6B23, #7C8B3D)',
      '--font-display': '"Bebas Neue", cursive', '--font-body': '"IBM Plex Sans", sans-serif',
    }
  },

  neon_green: {
    id: 'neon_green',
    name: 'Neon Green',
    description: 'Electric matrix green on deep black',
    preview: ['#39FF14', '#00CC44', '#0A1A0A'],
    vars: {
      '--bg-primary': '#0A0F0A', '--bg-secondary': '#0F1A0F', '--bg-card': '#121F12', '--bg-sidebar': '#0D160D',
      '--accent-primary': '#39FF14', '--accent-secondary': '#00CC44', '--accent-soft': '#1A3A1A', '--accent-hover': '#2ECC0F',
      '--text-primary': '#D4FFD4', '--text-secondary': '#7ACC7A', '--text-muted': '#4A7A4A',
      '--border': '#1F3A1F', '--border-strong': '#2F5A2F',
      '--success': '#39FF14', '--danger': '#FF4444', '--warning': '#FFD700', '--info': '#44DDFF',
      '--shadow': '0 4px 24px rgba(57,255,20,0.15)', '--shadow-card': '0 2px 12px rgba(57,255,20,0.10)',
      '--gradient-hero': 'linear-gradient(135deg, #0A0F0A 0%, #0F1A0F 50%, #121F12 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #39FF14, #00CC44)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"IBM Plex Sans", sans-serif',
    }
  },

  violet_dream: {
    id: 'violet_dream',
    name: 'Violet Dream',
    description: 'Rich violets and soft lavender',
    preview: ['#8E44AD', '#BB6BD9', '#E8D5F2'],
    vars: {
      '--bg-primary': '#FAF6FF', '--bg-secondary': '#F0E5FA', '--bg-card': '#FFFFFF', '--bg-sidebar': '#F4ECFC',
      '--accent-primary': '#8E44AD', '--accent-secondary': '#BB6BD9', '--accent-soft': '#E8D5F2', '--accent-hover': '#7A369A',
      '--text-primary': '#2A1438', '--text-secondary': '#5E3A75', '--text-muted': '#9B7AB0',
      '--border': '#E0CCF0', '--border-strong': '#C9A8E0',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#F39C12', '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(142,68,173,0.12)', '--shadow-card': '0 2px 12px rgba(142,68,173,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #F0E5FA 0%, #FAF6FF 50%, #F4ECFC 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #8E44AD, #BB6BD9)',
      '--font-display': '"Playfair Display", serif', '--font-body': '"Lato", sans-serif',
    }
  },

  cyan_wave: {
    id: 'cyan_wave',
    name: 'Cyan Wave',
    description: 'Cool cyan and aqua tones',
    preview: ['#00BCD4', '#26C6DA', '#B2EBF2'],
    vars: {
      '--bg-primary': '#F0FCFF', '--bg-secondary': '#DDF6FA', '--bg-card': '#FFFFFF', '--bg-sidebar': '#E6F9FC',
      '--accent-primary': '#00ACC1', '--accent-secondary': '#26C6DA', '--accent-soft': '#B2EBF2', '--accent-hover': '#0097A7',
      '--text-primary': '#0A2A30', '--text-secondary': '#2A6A75', '--text-muted': '#6AAAB5',
      '--border': '#BCE8F0', '--border-strong': '#90D5E0',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#F39C12', '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(0,172,193,0.12)', '--shadow-card': '0 2px 12px rgba(0,172,193,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #DDF6FA 0%, #F0FCFF 50%, #E6F9FC 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #00ACC1, #26C6DA)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"Source Sans 3", sans-serif',
    }
  },

  black_silver: {
    id: 'black_silver',
    name: 'Black & Silver',
    description: 'Sleek black with brushed silver',
    preview: ['#1A1A1A', '#C0C0C0', '#888888'],
    vars: {
      '--bg-primary': '#121212', '--bg-secondary': '#1C1C1C', '--bg-card': '#222222', '--bg-sidebar': '#181818',
      '--accent-primary': '#C0C0C0', '--accent-secondary': '#E8E8E8', '--accent-soft': '#333333', '--accent-hover': '#A8A8A8',
      '--text-primary': '#F0F0F0', '--text-secondary': '#B0B0B0', '--text-muted': '#707070',
      '--border': '#333333', '--border-strong': '#4A4A4A',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#F39C12', '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(0,0,0,0.40)', '--shadow-card': '0 2px 12px rgba(0,0,0,0.30)',
      '--gradient-hero': 'linear-gradient(135deg, #121212 0%, #1C1C1C 50%, #222222 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #C0C0C0, #888888)',
      '--font-display': '"Bebas Neue", cursive', '--font-body': '"DM Sans", sans-serif',
    }
  },

  red_gold: {
    id: 'red_gold',
    name: 'Red & Gold',
    description: 'Royal crimson with luxurious gold',
    preview: ['#A01818', '#FFD700', '#3A0A0A'],
    vars: {
      '--bg-primary': '#1A0606', '--bg-secondary': '#260A0A', '--bg-card': '#2E0D0D', '--bg-sidebar': '#200808',
      '--accent-primary': '#D4AF37', '--accent-secondary': '#FFD700', '--accent-soft': '#4A1515', '--accent-hover': '#B8941F',
      '--text-primary': '#FFE8C8', '--text-secondary': '#D4A878', '--text-muted': '#8A6448',
      '--border': '#4A1818', '--border-strong': '#6A2525',
      '--success': '#2ECC71', '--danger': '#FF5555', '--warning': '#FFD700', '--info': '#5499C7',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(212,175,55,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #1A0606 0%, #260A0A 50%, #2E0D0D 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #A01818, #FFD700)',
      '--font-display': '"Cinzel", serif', '--font-body': '"Raleway", sans-serif',
    }
  },

  pastel_dream: {
    id: 'pastel_dream',
    name: 'Pastel Dream',
    description: 'Soft pastel pink, blue and purple blend',
    preview: ['#FFB3D9', '#B3D9FF', '#D9B3FF'],
    vars: {
      '--bg-primary': '#FDF7FF', '--bg-secondary': '#F5EDFA', '--bg-card': '#FFFFFF', '--bg-sidebar': '#F8F0FC',
      '--accent-primary': '#C58BE0', '--accent-secondary': '#8BB8E8', '--accent-soft': '#F0D9FA', '--accent-hover': '#B070D0',
      '--text-primary': '#3A2A45', '--text-secondary': '#6A5A78', '--text-muted': '#A595B0',
      '--border': '#E8D5F0', '--border-strong': '#D0B8E0',
      '--success': '#7ED9A0', '--danger': '#FF9999', '--warning': '#FFCC80', '--info': '#90C8F0',
      '--shadow': '0 4px 24px rgba(197,139,224,0.12)', '--shadow-card': '0 2px 12px rgba(197,139,224,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #F5EDFA 0%, #FDF7FF 50%, #F8F0FC 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #FFB3D9, #B3D9FF)',
      '--font-display': '"Fredoka One", cursive', '--font-body': '"Nunito", sans-serif',
    }
  },

  dark_purple: {
    id: 'dark_purple', name: 'Dark Purple', description: 'Deep aubergine with lavender glow',
    preview: ['#1E0F2E', '#9D4EDD', '#C77DFF'],
    vars: {
      '--bg-primary': '#150A20', '--bg-secondary': '#1E0F2E', '--bg-card': '#251338', '--bg-sidebar': '#1A0C28',
      '--accent-primary': '#9D4EDD', '--accent-secondary': '#C77DFF', '--accent-soft': '#2E1A42', '--accent-hover': '#8038C8',
      '--text-primary': '#EDE0FA', '--text-secondary': '#B79AD0', '--text-muted': '#7A5F95',
      '--border': '#33204A', '--border-strong': '#4A2F6A',
      '--success': '#2ECC71', '--danger': '#FF5566', '--warning': '#FFB627', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(157,78,221,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #150A20 0%, #1E0F2E 50%, #251338 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #9D4EDD, #C77DFF)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"DM Sans", sans-serif',
    }
  },

  dark_military: {
    id: 'dark_military', name: 'Dark Military', description: 'Tactical olive-black, Obscura ready',
    preview: ['#12160C', '#6B7C32', '#9AAB52'],
    vars: {
      '--bg-primary': '#0E1109', '--bg-secondary': '#161B0F', '--bg-card': '#1C2213', '--bg-sidebar': '#12160C',
      '--accent-primary': '#7C8B3D', '--accent-secondary': '#9AAB52', '--accent-soft': '#252D17', '--accent-hover': '#677430',
      '--text-primary': '#E4E8D5', '--text-secondary': '#A8B088', '--text-muted': '#6E7855',
      '--border': '#28301A', '--border-strong': '#3A4528',
      '--success': '#7ED957', '--danger': '#D9534F', '--warning': '#E0A82E', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(124,139,61,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #0E1109 0%, #161B0F 50%, #1C2213 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #6B7C32, #9AAB52)',
      '--font-display': '"Bebas Neue", cursive', '--font-body': '"IBM Plex Sans", sans-serif',
    }
  },

  black_gold: {
    id: 'black_gold', name: 'Black & Gold', description: 'Pure black with rich gold',
    preview: ['#0A0A0A', '#FFD700', '#D4AF37'],
    vars: {
      '--bg-primary': '#080808', '--bg-secondary': '#121212', '--bg-card': '#1A1A1A', '--bg-sidebar': '#0D0D0D',
      '--accent-primary': '#D4AF37', '--accent-secondary': '#FFD700', '--accent-soft': '#2A2410', '--accent-hover': '#B8941F',
      '--text-primary': '#F5EDD8', '--text-secondary': '#C4B585', '--text-muted': '#7A7050',
      '--border': '#2A2515', '--border-strong': '#403818',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#FFD700', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.55)', '--shadow-card': '0 2px 12px rgba(212,175,55,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #080808 0%, #121212 50%, #1A1A1A 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #D4AF37, #FFD700)',
      '--font-display': '"Cinzel", serif', '--font-body': '"Raleway", sans-serif',
    }
  },

  green_gold: {
    id: 'green_gold', name: 'Green & Gold', description: 'Regal forest green with gold',
    preview: ['#0C1F12', '#D4AF37', '#2E8B57'],
    vars: {
      '--bg-primary': '#091A0F', '--bg-secondary': '#0F2417', '--bg-card': '#142E1D', '--bg-sidebar': '#0B1F13',
      '--accent-primary': '#D4AF37', '--accent-secondary': '#3FA86A', '--accent-soft': '#1A3825', '--accent-hover': '#B8941F',
      '--text-primary': '#E8F0E0', '--text-secondary': '#9CC0A8', '--text-muted': '#5E8068',
      '--border': '#1E3D2A', '--border-strong': '#2E5840',
      '--success': '#3FA86A', '--danger': '#E74C3C', '--warning': '#D4AF37', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(212,175,55,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #091A0F 0%, #0F2417 50%, #142E1D 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #2E8B57, #D4AF37)',
      '--font-display': '"Cinzel", serif', '--font-body': '"Lato", sans-serif',
    }
  },

  royal_blue_gold: {
    id: 'royal_blue_gold', name: 'Royal Blue & Gold', description: 'Navy with luxurious gold',
    preview: ['#0A1432', '#FFD700', '#1E3A8A'],
    vars: {
      '--bg-primary': '#070F26', '--bg-secondary': '#0D1A3A', '--bg-card': '#122248', '--bg-sidebar': '#0A1430',
      '--accent-primary': '#E6B829', '--accent-secondary': '#FFD700', '--accent-soft': '#1A2A55', '--accent-hover': '#C89F1F',
      '--text-primary': '#E6ECFA', '--text-secondary': '#9CB0D8', '--text-muted': '#5E7099',
      '--border': '#1C2F5A', '--border-strong': '#2A4480',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#FFD700', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(230,184,41,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #070F26 0%, #0D1A3A 50%, #122248 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #1E3A8A, #FFD700)',
      '--font-display': '"Cinzel", serif', '--font-body': '"Raleway", sans-serif',
    }
  },

  royal_blue_silver: {
    id: 'royal_blue_silver', name: 'Royal Blue & Silver', description: 'Navy with cool silver',
    preview: ['#0A1432', '#C0C8D8', '#1E3A8A'],
    vars: {
      '--bg-primary': '#070F26', '--bg-secondary': '#0D1A3A', '--bg-card': '#122248', '--bg-sidebar': '#0A1430',
      '--accent-primary': '#B0BCD0', '--accent-secondary': '#E0E8F5', '--accent-soft': '#1A2A55', '--accent-hover': '#94A3BC',
      '--text-primary': '#E6ECFA', '--text-secondary': '#9CB0D8', '--text-muted': '#5E7099',
      '--border': '#1C2F5A', '--border-strong': '#2A4480',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#F39C12', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(176,188,208,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #070F26 0%, #0D1A3A 50%, #122248 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #1E3A8A, #C0C8D8)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"DM Sans", sans-serif',
    }
  },

  orange_black: {
    id: 'orange_black', name: 'Orange & Black', description: 'High-contrast tactical orange',
    preview: ['#0D0D0D', '#FF6B1A', '#FF8C42'],
    vars: {
      '--bg-primary': '#0A0A0A', '--bg-secondary': '#141414', '--bg-card': '#1C1C1C', '--bg-sidebar': '#0F0F0F',
      '--accent-primary': '#FF6B1A', '--accent-secondary': '#FF8C42', '--accent-soft': '#2E1A0D', '--accent-hover': '#E55A0F',
      '--text-primary': '#F5E8DD', '--text-secondary': '#C0A590', '--text-muted': '#7A6855',
      '--border': '#2A1F15', '--border-strong': '#40301F',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#FF8C42', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.55)', '--shadow-card': '0 2px 12px rgba(255,107,26,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #0A0A0A 0%, #141414 50%, #1C1C1C 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #FF6B1A, #FF8C42)',
      '--font-display': '"Bebas Neue", cursive', '--font-body': '"IBM Plex Sans", sans-serif',
    }
  },

  magenta: {
    id: 'magenta', name: 'Magenta', description: 'Vivid dark magenta and pink',
    preview: ['#2A0A22', '#E91E8C', '#FF4DB8'],
    vars: {
      '--bg-primary': '#1F0719', '--bg-secondary': '#2A0A22', '--bg-card': '#36102C', '--bg-sidebar': '#240820',
      '--accent-primary': '#E91E8C', '--accent-secondary': '#FF4DB8', '--accent-soft': '#421535', '--accent-hover': '#C8167A',
      '--text-primary': '#FAE0F0', '--text-secondary': '#D098BC', '--text-muted': '#955F82',
      '--border': '#451838', '--border-strong': '#642552',
      '--success': '#2ECC71', '--danger': '#FF5566', '--warning': '#FFB627', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(233,30,140,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #1F0719 0%, #2A0A22 50%, #36102C 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #E91E8C, #FF4DB8)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"Nunito", sans-serif',
    }
  },

  charcoal_amber: {
    id: 'charcoal_amber', name: 'Charcoal & Amber', description: 'Neutral dark gray, warm amber glow',
    preview: ['#1C1C1E', '#FFA62B', '#FFB627'],
    vars: {
      '--bg-primary': '#161618', '--bg-secondary': '#1F1F22', '--bg-card': '#27272B', '--bg-sidebar': '#1A1A1D',
      '--accent-primary': '#FFA62B', '--accent-secondary': '#FFB627', '--accent-soft': '#332817', '--accent-hover': '#E08D1A',
      '--text-primary': '#ECECEE', '--text-secondary': '#A8A8B0', '--text-muted': '#6E6E78',
      '--border': '#303036', '--border-strong': '#45454D',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#FFB627', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(255,166,43,0.10)',
      '--gradient-hero': 'linear-gradient(135deg, #161618 0%, #1F1F22 50%, #27272B 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #FFA62B, #FFB627)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"DM Sans", sans-serif',
    }
  },

  deep_ocean: {
    id: 'deep_ocean', name: 'Deep Ocean', description: 'Dark navy to teal depths',
    preview: ['#0A1A26', '#1ABC9C', '#16A0C8'],
    vars: {
      '--bg-primary': '#071620', '--bg-secondary': '#0C2230', '--bg-card': '#102C3D', '--bg-sidebar': '#091B27',
      '--accent-primary': '#1ABC9C', '--accent-secondary': '#16A0C8', '--accent-soft': '#16323F', '--accent-hover': '#15A085',
      '--text-primary': '#E0F0F5', '--text-secondary': '#94BCC8', '--text-muted': '#567A85',
      '--border': '#163645', '--border-strong': '#225065',
      '--success': '#1ABC9C', '--danger': '#E74C3C', '--warning': '#F39C12', '--info': '#16A0C8',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(26,188,156,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #071620 0%, #0C2230 50%, #102C3D 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #16A0C8, #1ABC9C)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"Source Sans 3", sans-serif',
    }
  },

  obscura: {
    id: 'obscura', name: 'Obscura', description: 'Signature tactical green-black',
    preview: ['#0C0F0D', '#4A7C59', '#88B098'],
    vars: {
      '--bg-primary': '#080A09', '--bg-secondary': '#101412', '--bg-card': '#161B18', '--bg-sidebar': '#0C100E',
      '--accent-primary': '#5A9A6E', '--accent-secondary': '#88B098', '--accent-soft': '#1C2620', '--accent-hover': '#48825A',
      '--text-primary': '#DCE8E0', '--text-secondary': '#94A89C', '--text-muted': '#5A6E62',
      '--border': '#1E2823', '--border-strong': '#2E3D34',
      '--success': '#5A9A6E', '--danger': '#C0504D', '--warning': '#D6A338', '--info': '#5B8AA8',
      '--shadow': '0 4px 24px rgba(0,0,0,0.50)', '--shadow-card': '0 2px 12px rgba(90,154,110,0.10)',
      '--gradient-hero': 'linear-gradient(135deg, #080A09 0%, #101412 50%, #161B18 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #4A7C59, #88B098)',
      '--font-display': '"Bebas Neue", cursive', '--font-body': '"IBM Plex Sans", sans-serif',
    }
  },

  crimson_black: {
    id: 'crimson_black', name: 'Crimson & Black', description: 'Blood red on near-black',
    preview: ['#0D0606', '#C0181C', '#E63946'],
    vars: {
      '--bg-primary': '#0A0505', '--bg-secondary': '#140A0A', '--bg-card': '#1C0E0E', '--bg-sidebar': '#0E0707',
      '--accent-primary': '#C0181C', '--accent-secondary': '#E63946', '--accent-soft': '#2E1212', '--accent-hover': '#A01418',
      '--text-primary': '#F5DDDD', '--text-secondary': '#C09595', '--text-muted': '#7A5555',
      '--border': '#2A1515', '--border-strong': '#402020',
      '--success': '#2ECC71', '--danger': '#E63946', '--warning': '#F39C12', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.55)', '--shadow-card': '0 2px 12px rgba(192,24,28,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #0A0505 0%, #140A0A 50%, #1C0E0E 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #C0181C, #E63946)',
      '--font-display': '"Bebas Neue", cursive', '--font-body': '"DM Sans", sans-serif',
    }
  },

  teal_copper: {
    id: 'teal_copper', name: 'Teal & Copper', description: 'Dark teal with warm copper',
    preview: ['#0C1F1E', '#C87941', '#E89B5C'],
    vars: {
      '--bg-primary': '#091817', '--bg-secondary': '#0F2120', '--bg-card': '#142B29', '--bg-sidebar': '#0B1C1B',
      '--accent-primary': '#D08850', '--accent-secondary': '#E89B5C', '--accent-soft': '#1E3634', '--accent-hover': '#B5713E',
      '--text-primary': '#E0EDEB', '--text-secondary': '#94B8B4', '--text-muted': '#567570',
      '--border': '#1C3835', '--border-strong': '#2A524D',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#E89B5C', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.45)', '--shadow-card': '0 2px 12px rgba(208,136,80,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #091817 0%, #0F2120 50%, #142B29 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #1ABC9C, #C87941)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"Source Sans 3", sans-serif',
    }
  },

  vampire: {
    id: 'vampire', name: 'Vampire', description: 'Gothic black, burgundy and silver',
    preview: ['#0D0808', '#8B1A2F', '#A8A0A2'],
    vars: {
      '--bg-primary': '#0A0606', '--bg-secondary': '#140C0D', '--bg-card': '#1C1213', '--bg-sidebar': '#0E0809',
      '--accent-primary': '#9B2335', '--accent-secondary': '#B83A4C', '--accent-soft': '#2A1518', '--accent-hover': '#7E1B2A',
      '--text-primary': '#E8DDDF', '--text-secondary': '#B098A0', '--text-muted': '#705860',
      '--border': '#28171A', '--border-strong': '#3D2428',
      '--success': '#2ECC71', '--danger': '#E63946', '--warning': '#D6A338', '--info': '#8B8A9A',
      '--shadow': '0 4px 24px rgba(0,0,0,0.55)', '--shadow-card': '0 2px 12px rgba(155,35,53,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #0A0606 0%, #140C0D 50%, #1C1213 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #8B1A2F, #A8A0A2)',
      '--font-display': '"Cinzel", serif', '--font-body': '"Raleway", sans-serif',
    }
  },

  cyberpunk: {
    id: 'cyberpunk', name: 'Cyberpunk', description: 'Neon magenta and cyan on black',
    preview: ['#0A0A14', '#FF2A6D', '#05D9E8'],
    vars: {
      '--bg-primary': '#070710', '--bg-secondary': '#0E0E1C', '--bg-card': '#141426', '--bg-sidebar': '#0A0A16',
      '--accent-primary': '#FF2A6D', '--accent-secondary': '#05D9E8', '--accent-soft': '#241327', '--accent-hover': '#E01F5C',
      '--text-primary': '#E8E8FA', '--text-secondary': '#9A9AC8', '--text-muted': '#5E5E85',
      '--border': '#1E1E38', '--border-strong': '#2E2E54',
      '--success': '#05E89A', '--danger': '#FF2A6D', '--warning': '#FFD700', '--info': '#05D9E8',
      '--shadow': '0 4px 24px rgba(0,0,0,0.55)', '--shadow-card': '0 2px 12px rgba(255,42,109,0.15)',
      '--gradient-hero': 'linear-gradient(135deg, #070710 0%, #0E0E1C 50%, #141426 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #FF2A6D, #05D9E8)',
      '--font-display': '"Outfit", sans-serif', '--font-body': '"IBM Plex Sans", sans-serif',
    }
  },

  rose_gold: {
    id: 'rose_gold', name: 'Rose Gold', description: 'Soft blush with metallic rose',
    preview: ['#FFF0F0', '#B76E79', '#E8B4B8'],
    vars: {
      '--bg-primary': '#FFF6F4', '--bg-secondary': '#FCEAE8', '--bg-card': '#FFFFFF', '--bg-sidebar': '#FDF0EE',
      '--accent-primary': '#B76E79', '--accent-secondary': '#D4969C', '--accent-soft': '#F5DDDC', '--accent-hover': '#A05963',
      '--text-primary': '#3D2A2D', '--text-secondary': '#7A5A5E', '--text-muted': '#B09095',
      '--border': '#F0D5D3', '--border-strong': '#E0B8B5',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#F39C12', '--info': '#3498DB',
      '--shadow': '0 4px 24px rgba(183,110,121,0.12)', '--shadow-card': '0 2px 12px rgba(183,110,121,0.08)',
      '--gradient-hero': 'linear-gradient(135deg, #FCEAE8 0%, #FFF6F4 50%, #FDF0EE 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #B76E79, #E8B4B8)',
      '--font-display': '"Playfair Display", serif', '--font-body': '"Lato", sans-serif',
    }
  },

  dark_rose_gold: {
    id: 'dark_rose_gold', name: 'Dark Rose Gold', description: 'Espresso base with metallic rose-gold',
    preview: ['#1A1012', '#D89AA0', '#E8B89A'],
    vars: {
      '--bg-primary': '#150C0E', '--bg-secondary': '#1F1416', '--bg-card': '#281A1D', '--bg-sidebar': '#180E10',
      '--accent-primary': '#D89AA0', '--accent-secondary': '#E8B89A', '--accent-soft': '#33201F', '--accent-hover': '#C07F86',
      '--text-primary': '#F2E2DF', '--text-secondary': '#C4A39E', '--text-muted': '#856863',
      '--border': '#2E1E20', '--border-strong': '#452E30',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#E8B89A', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.50)', '--shadow-card': '0 2px 12px rgba(216,154,160,0.14)',
      '--gradient-hero': 'linear-gradient(135deg, #150C0E 0%, #1F1416 50%, #281A1D 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #D89AA0, #E8B89A)',
      '--font-display': '"Playfair Display", serif', '--font-body': '"Raleway", sans-serif',
    }
  },

  purple_gold: {
    id: 'purple_gold', name: 'Purple & Gold', description: 'Deep royal purple with luxurious gold',
    preview: ['#1A0F2E', '#D4AF37', '#9D4EDD'],
    vars: {
      '--bg-primary': '#140A24', '--bg-secondary': '#1D0F33', '--bg-card': '#251440', '--bg-sidebar': '#180B2C',
      '--accent-primary': '#D4AF37', '--accent-secondary': '#E6C84F', '--accent-soft': '#2E1A4A', '--accent-hover': '#B8941F',
      '--text-primary': '#EDE2FA', '--text-secondary': '#B79AD0', '--text-muted': '#7A5F95',
      '--border': '#2E1A4A', '--border-strong': '#452968',
      '--success': '#2ECC71', '--danger': '#E74C3C', '--warning': '#D4AF37', '--info': '#5DADE2',
      '--shadow': '0 4px 24px rgba(0,0,0,0.50)', '--shadow-card': '0 2px 12px rgba(212,175,55,0.12)',
      '--gradient-hero': 'linear-gradient(135deg, #140A24 0%, #1D0F33 50%, #251440 100%)',
      '--gradient-accent': 'linear-gradient(135deg, #9D4EDD, #D4AF37)',
      '--font-display': '"Cinzel", serif', '--font-body': '"Raleway", sans-serif',
    }
  }
};

export const DEFAULT_THEME = 'brazyy_pink';

export const BANNERS = [
  {
    id: 'pink_office',
    name: 'Pink Office',
    url: '/banners/pink-office.png',
    description: 'Soft pink workspace — cozy and welcoming'
  },
  {
    id: 'midnight_clock',
    name: 'Midnight Clock',
    url: '/banners/midnight-clock.png',
    description: 'Dark and dramatic with golden gears'
  },
  {
    id: 'custom',
    name: 'Custom URL',
    url: null,
    description: 'Use your own image or gif URL'
  }
];

export function applyTheme(themeId) {
  const theme = THEMES[themeId] || THEMES[DEFAULT_THEME];
  const root = document.documentElement;
  Object.entries(theme.vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
  localStorage.setItem('brazyy_theme', themeId);
}

export function getStoredTheme() {
  return localStorage.getItem('brazyy_theme') || DEFAULT_THEME;
}
